// extracted by mini-css-extract-plugin
export default {"items":"HallsPhoto_items__0R8OL","card":"HallsPhoto_card__EXI-a","cardImage":"HallsPhoto_cardImage__yWzG5","title":"HallsPhoto_title__e9qSz"};